import { useApolloClient } from '@apollo/client';
import axios from 'axios';
import { useGeoQueryLazyQuery } from 'graphql/generated';

import { GEO_QUERIES } from './GeoQueries.graphql';

export const useGeo = () => {
  const client = useApolloClient();
  // const [queryZip] = useGeoQueryLazyQuery();

  const getIpAddress = async () => {
    try {
      const result = await axios.get('https://api.ipify.org');

      if (result?.data) {
        // console.log('ipify', result.data);
        return result.data;
      }
    } catch (error: any) {
      console.log('get ip error', error.message);
    }
    return '';
  };

  const getGeoZip = async () => {
    try {
      const ipAddress = await getIpAddress();
      if (ipAddress) {
        // console.log('query for ip', ipAddress);
        const { data } = await client.query({
          query: GEO_QUERIES,
          variables: { ipAddress },
        });
        // console.log('data', data);
        if (data.geoQuery) return data.geoQuery;
      }
    } catch (error: any) {
      console.log('geoZip error', error.message);
    }
    return '';
  };

  return { getGeoZip };
};
